export function queryStringAsObject(url: string) {
	const obj = {};
	const splitted = url.split('?');

	if (splitted.length > 1) {
		splitted[1].split('&').forEach((pair) => {
			const pairs = pair.split('=');
			obj[pairs[0]] = decodeURIComponent(pairs[1]);
		});
	}

	return obj;
}
